<template>
    <div>
        <first />
        <second />
        <third />
        <fourth />
    </div>
</template>

<script src="./vendorPortal.js"></script>
<style src="./vendorPortal.css"></style>